export const DrilldownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="4" y1="6" x2="20" y2="6"></line>
      <line x1="4" y1="12" x2="15" y2="12"></line>
      <line x1="4" y1="18" x2="10" y2="18"></line>
    </svg>
  );
};
